module.exports = __webpack_public_path__ + "img/cszl-1.05d1a89f.png";